




























































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import ListView from '@/components/list/ListView.vue'
import PageTab from '@/components/ui/PageTab.vue'
import { vxm } from '@/store'
import { formatDateTimeString } from '@/utils/dateUtils'
import AuditLog from '@/models/audit-log/AuditLog'
import { Debounce } from 'lodash-decorators'

@Component({
  methods: { formatDateTimeString },
  components: {
    ListView,
    PageTab,
  },
})
export default class List extends Vue {
  private listViewKey = 0
  private loading = false

  private classes = []
  private logs = []

  private headers = []
  private rowActions = []

  private objectClassFilter = null
  private objectIdFilter = null
  private queryObjectClassFilter = null
  private queryObjectIdFilter = null

  private activeLog: AuditLog = null
  private auditLogDetailsDialog = false

  private allowShowDataTable = false

  created() {
    this.loading = true
    this.getClasses()
    this.setRowActions()
    this.setHeaders()
  }

  private get url() {
    return '/v4/sysop/auditlog'
  }

  private toggleAllowShowDataTable() {
    const hasClass = this.objectClassFilter !== null && this.objectClassFilter !== ''
    const hasId = this.objectIdFilter !== null && this.objectIdFilter !== ''
    if (hasClass || hasId) {
      this.allowShowDataTable = true
    }
    this.queryObjectIdFilter = this.objectIdFilter
    this.queryObjectClassFilter = this.objectClassFilter
  }

  private setHeaders() {
    this.headers = [
      {
        text: 'Time',
        value: 'time',
        filter: { disable: true },
        sortable: false,
      },
      {
        text: 'Site',
        value: 'siteId',
        filter: { disable: true },
        sortable: false,
      },
      {
        text: 'User',
        value: 'user.email',
        filter: { disable: true },
        sortable: false,
      },
      {
        text: 'Object class',
        value: 'objectClass',
        filter: { disable: true },
        sortable: false,
      },
      {
        text: 'Object ID',
        value: 'objectId',
        filter: { disable: true },
        sortable: false,
      },
      {
        text: 'Action',
        value: 'action',
        filter: { disable: true },
        sortable: false,
      },
      {
        text: '',
        value: 'actions',
        filter: { disable: true },
        sortable: false,
      },
    ]
  }

  private setRowActions() {
    this.rowActions = [
      {
        id: 'show',
        label: 'Details',
        click: (_, item) => {
          this.activeLog = item
          this.auditLogDetailsDialog = true
        },
      },
    ]
  }

  private getClasses() {
    this.$axios
      .get('/v4/sysop/auditlog/classes')
      .then((response) => {
        this.classes = response.data.data
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, 'Error fetching classes')
      })
      .finally(() => {
        this.loading = false
      })
  }

  private get formattedDiff() {
    if (!this.activeLog?.detail?.diff) return ''
    try {
      const pretty = JSON.stringify(this.activeLog.detail.diff, null, 2)
      return this.escapeHtml(pretty)
    } catch {
      return ''
    }
  }

  private escapeHtml(text) {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  }

  private get query() {
    return {
      objectClass: this.queryObjectClassFilter,
      objectId: this.queryObjectIdFilter,
    }
  }
}
